<!-- Step3 売掛金 -->
<template>
  <div class="egl-dialog-elm">
    <el-dialog
      :visible="isOpen"
      :title="$locale('dailyClosing.createDialog.title')"
      width="90%"
      class="egl-dialog"
      :modal="false"
      :show-close="true"
      :close-on-click-modal="false"
      @close="closeAction"
    >
      <el-form :disabled="isDetailMode" :model="detailData">
        <div class="module-item">
          <!-- 売掛金 and 同額を自動設定 -->
          <el-row :gutter="10">
            <el-col :span="16">
              <h2>{{ $locale("dailyClosing.accountsReceivableTable.title") }}</h2>
            </el-col>
            <el-col :span="8" class="ta-r">
              <el-button class="egl-btn-yellow" @click="setSameAmount">
                {{ $locale("dailyClosing.accountsReceivableTable.autoSetSameAmount") }}
              </el-button>
            </el-col>
          </el-row>

          <!-- 全レジ内金額の内訳計算表 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.title") }}</div>
          <AllCashAmounts
            :accountsReceivableType="accountsReceivableType"
            :receivableList="receivableList"
            :tableData="detailData.accountPayableInCashs.cashDetails"
            :isInitData.sync="isInitData"
            :actionType="actionType"
          ></AllCashAmounts>
          <hr class="dotted">

          <!-- レジ締め済取引の払戻・修正 / 過去営業日取引の追加 -->
          <!-- TODO: how to get this table data? -->
          <template v-if="isShowPastBizDayTrans">
            <div class="module-item-tit">{{ $locale("dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.title") }}</div>
            <PastBizDayTrans
              :accountsReceivableType="accountsReceivableType"
              :tableData="detailData.accountPayableInCashs.refundUpdateDetails"
              :isInitData.sync="isInitData"
              :actionType="actionType"
            ></PastBizDayTrans>
            <hr class="dotted">
          </template>
          <!-- レジ締め済取引の払戻・修正 / 過去営業日取引の追加 pastBusinessDayTransactionsTable  End -->

          <!-- 過不足精算表 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.title") }}</div>
          <TicketReplacement
            :accountsReceivableType="accountsReceivableType"
            :tableData="detailData.accountPayableInCashs.cashDetails"
            :isInitData="isInitData"
            :actionType="actionType"
          ></TicketReplacement>
          <hr class="dotted">

          <!-- その他営業収入の売掛金登録 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.accountsReceivableTable.otherOperatingIncomeAccountsReceivableRegistrationTable.title") }}</div>
          <OtherIncomeAccReceivableReg
            :otherRevList="otherRevList"
            :clientList="clientList"
            :tableData.sync="detailData.accountPayableInCashs.salesAccounts"
            v-bind="$attrs"
            v-on="$listeners"
            :isOpen="isOpen"
          ></OtherIncomeAccReceivableReg>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          class="egl-btn-white"
          @click="closeAction(true, false)"
        >{{ $locale("dailyClosing.prevPage") }}</el-button>
        <el-button
          :class="nextBtnDisabled ? 'egl-btn-gray' : 'egl-btn-yellow'"
          :disabled="nextBtnDisabled"
          @click="next_fn"
        >{{ $locale("dailyClosing.createDialog.basicInfo.next") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { checkValidData } from "@/utils/common";

import { updateDayCloseAccountReceivable } from "@/helpers/service/api/dailyClosingNew";
import { receivableType } from "@/assets/js/dailyClosingNew";
import AllCashAmounts from "./AllCashAmounts";
import PastBizDayTrans from "./PastBizDayTrans";
import TicketReplacement from "./TicketReplacement";
import OtherIncomeAccReceivableReg from "./OtherIncomeAccReceivableReg";

export default {
  name: "AccountsReceivable",
  components: {
    AllCashAmounts,
    PastBizDayTrans,
    TicketReplacement,
    OtherIncomeAccReceivableReg,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: "",
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    otherRevList: {
      type: Array,
      default: () => [],
    },
    receivableList: { // couponType, nationalTicket, otherNationalTicket, settlement
      type: Object,
      default: () => ({}),
    },
    detailData: {
      type: Object,
      default: () => {},
    },
    lastLaunchDialog: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isInitData: true,
      accountsReceivableType: receivableType(),
    };
  },
  computed: {
    isDetailMode() {
      return this.actionType === "detail";
    },
    nextBtnDisabled() {
      const { cashDetails } = this.detailData.accountPayableInCashs;

      if (!cashDetails) { return true; }

      const {
        couponType,
        nationalTicket,
        settlement,
      } = cashDetails;

      if (couponType.length === 0 && nationalTicket.length === 0 && settlement.length === 0) {
        return false;
      }

      let result = true;
      let _objNameArray = [];

      Object.keys(cashDetails).forEach(_key => {
        this.detailData.accountPayableInCashs.cashDetails[_key].forEach(_list => {
          if (_list.isNewRow) {
            _objNameArray.push(_list.name);
          }
        });
      });

      result = _objNameArray.includes("");

      return result || (this.isInitData && !this.isDetailMode);
    },
    isShowPastBizDayTrans() {
      if (!this.detailData.accountPayableInCashs || !this.detailData.accountPayableInCashs.refundUpdateDetails) {
        return false;
      }

      let result = true;
      let countsArray = Object.keys(this.detailData.accountPayableInCashs.refundUpdateDetails).map(_key =>
        this.detailData.accountPayableInCashs.refundUpdateDetails[_key].length === 0);

      result = countsArray.includes(false);

      return result;
    },
    isOpen: {
      get() {
        return this.visible;
      },
      set() {
        return !this.visible;
      }
    }
  },
  watch: {
    visible(_nv) {
      if (_nv) {
        this.restructureData();

        if (this.lastLaunchDialog === "step4") {
          this.isInitData = false;
        }
      } else {
        this.isInitData = true;
      }
    },
  },
  methods: {
    restructureData() {
      if (
        !this.detailData.accountPayableInCashs.cashDetails
        || this.detailData.accountPayableInCashs.cashDetails.length === 0
      ) {
        return [];
      }

      const _cashDetails = tranfResData(this.detailData.accountPayableInCashs.cashDetails);
      const _addPropFn = objArray => {
        objArray.forEach(_item => {
          const { actualAmount, amount, actualSales, dayActualQty, cashQty, actualQty } = _item;
          const _dayQty = dayActualQty - actualQty;
          const _cashBalance = actualAmount - amount;
          const _dayInsufficient = actualSales - actualAmount;

          _item.dayQty = _dayQty;
          _item.cashBalance = _cashBalance;
          _item.saleQty = _cashBalance - _dayInsufficient;
          _item.dayInsufficient = _dayInsufficient;
          _item.insufficientTotal = cashQty + _dayQty;
        });

        return objArray;
      };

      Object.keys(_cashDetails).forEach(_key => {
        if (_cashDetails[_key].length > 0) {
          const _subList = _addPropFn(_cashDetails[_key], _key);
          _cashDetails[_key] = _subList;
        }
      });

      this.$emit("update:detailData", {
        ...tranfResData(this.detailData),
        accountPayableInCashs: {
          ...tranfResData(this.detailData.accountPayableInCashs),
          cashDetails: _cashDetails,
          // refundUpdateDetails: _cashDetails, // TODO: mock data!!!
        },
      });
    },
    closeAction(_goPrevStep = false, _goNextStep = false) {
      this.$emit("closeDialogFn", {
        name: "step3",
        prevStep: _goPrevStep,
        nextStep: _goNextStep,
      });
    },
    setSameAmount() {
      /**
       * 當用戶點擊 "同額を自動設定" 的按鍵
       * 系統自動copy
       * レジ実件数 -> 日次実件数
       * レジ実売上 -> 日次実売上
       */

      if (typeof this.detailData.accountPayableInCashs.cashDetails === "undefined") {
        return;
      }

      Object.keys(this.detailData.accountPayableInCashs.cashDetails).forEach(_key => {
        this.detailData.accountPayableInCashs.cashDetails[_key].forEach(_list => {
          _list.dayActualQty = _list.actualQty;
          _list.actualSales = _list.actualAmount;
        });
      });

      this.isInitData = false;
    },
    next_fn() {
      if (this.isDetailMode) {
        this.closeAction(false, true);
      } else {
        const { accountPayableInCashs } = tranfResData(this.detailData);
        const requestParam = {
          ...accountPayableInCashs,
          shortage: accountPayableInCashs.cashDetails,
          salesAccounts: accountPayableInCashs.salesAccounts,
        };

        requestParam.salesAccounts.forEach(_sa => {
          const _isValidData = checkValidData(_sa); 
          _sa.isValidData = _isValidData;
        });
        requestParam.salesAccounts = requestParam.salesAccounts.filter(_sa => _sa.isValidData);

        updateDayCloseAccountReceivable(requestParam).then(res => {
          if (res.success) {
            const _resData = res.data ? tranfResData(res.data) : {};
            const { theaterTicket: _existTheaterTicket } = this.detailData;

            const _theaterTicket = {
              create: _resData,
              edit: _resData,
              detail: _existTheaterTicket,
            };

            this.$emit("update:detailData", {
              ...tranfResData(this.detailData),
              theaterTicket: _theaterTicket[this.actionType],
            });

            this.closeAction(false, true);
          }
        });
      }
    },
  },
};
</script>

